import { useState } from 'react';
import { Button, Modal, message } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ButtonProps } from 'antd/es/button';
import { cancelPreDispute, CommonRefund, DisputeOperate } from 'services/api/return';
import DisputeModal from './DisputeModal';
import { useRequest } from 'ahooks';

interface Props extends Omit<ButtonProps, 'onClick'>, CommonRefund {
  internalStoreId: string;
  internalTradeId: string;
  onSuccess?: () => void;
  preDisputeContent?: string;
  region?: General.UpperCaseRegion;
}

/** 向Shopee争议; */
const PreDisputeToShopee = (props: Props) => {
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const { runAsync, loading } = useRequest((data) => cancelPreDispute(data), {
    manual: true,
  });
  const {
    internalStoreId,
    internalTradeId,
    externalStoreId,
    onSuccess,
    returnSn,
    externalTradeId,
    preDisputeContent,
    region,
    ...btnProps
  } = props;
  return (
    <>
      <Button size="small" {...btnProps} onClick={() => setVisible(true)}>
        {!!preDisputeContent ? t('修改预填写争议') : t('预填写争议')}
      </Button>
      {visible && (
        <DisputeModal
          title={!!preDisputeContent ? t('修改预填写争议') : t('预填写争议')}
          visible={visible}
          setVisible={setVisible}
          internalStoreId={internalStoreId}
          externalStoreId={externalStoreId}
          internalTradeId={internalTradeId}
          externalTradeId={externalTradeId}
          returnSn={returnSn}
          onSuccess={onSuccess}
          disputeOperate={!!preDisputeContent ? DisputeOperate.修改预争议 : DisputeOperate.预争议}
          preDisputeContent={preDisputeContent}
          region={region}
          footerExtra={
            <Button
              loading={loading}
              type="link"
              className="cursor-pointer !text-[var(--fett-text-secondary)] !px-0"
              onClick={() => {
                Modal.confirm({
                  title: '确认要撤销预争议吗？',
                  onOk: () => {
                    runAsync({
                      returnSn,
                      externalStoreId,
                      externalTradeId,
                    })
                      .then(() => {
                        setVisible(false);
                        onSuccess?.();
                      })
                      .catch(() => {
                        message.error(t('translation.操作失败，请稍后再试'));
                      });
                  },
                });
              }}
            >
              {t('撤销预争议')}
            </Button>
          }
          okText={t('phrase.保存')}
        />
      )}
    </>
  );
};

export default PreDisputeToShopee;
